const Header = () => {
  return (
    <div className="header">
      <div className="headerContent">
        <div className="logoBox">
          <a href="http://edu.emir.gov.ru/">
            <img src="https://edu.emir.gov.ru/_nuxt/logo.0b770bee.svg" alt="" />
          </a>
          <div className="logoText">
            <div>Единый Методический Информационный Ресурс</div>
            <div>
              Официальный ресурс Министерства спорта Российской Федерации
            </div>
          </div>
        </div>
        <div className="headerButtons">
          <a href="http://emir.vniifk.ru/feedback">Обратная связь</a>
          <a href="http://emir.vniifk.ru/about">О портале</a>
          <a className="hotline" href="http://emir.vniifk.ru/harmonization">
            Горячая линия по гармонизации
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;
